import { Button, Heading, Stack, Text } from '@chakra-ui/react';
import { reactEvents } from '@bridge/reactEvents';
import { BodyOverride } from '@texas/components/shared/BodyOverride';
import { useTranslation } from 'react-i18next';

export function ArticleNotFoundPage() {
  const { t } = useTranslation();
  return (
    <BodyOverride>
      <Stack
        as="main"
        bg="entityDirectory.canvas"
        color="entityDirectory.text"
        minH="calc(100dvh - 2rem)"
        align="center"
        justify="center"
        p={{ base: 6, md: 10 }}
      >
        <Stack
          role="alert"
          bg="entityDirectory.surface"
          border="1px solid"
          borderColor="entityDirectory.border"
          p={{ base: 6, md: 10 }}
          spacing={5}
          maxW="560px"
          w="full"
          textAlign="center"
          align="center"
        >
          <Text color="entityDirectory.mutedText" fontSize="sm">
            404
          </Text>
          <Heading as="h1" fontFamily="barlow" size="lg">
            {t('article.notFound.title')}
          </Heading>
          <Text color="entityDirectory.mutedText">
            {t('article.notFound.description')}
          </Text>
          <Button
            variant="texas-solid"
            w={{ base: 'full', sm: 'auto' }}
            onClick={() =>
              reactEvents.routingChanged.dispatch({ to: 'searcharticles' })
            }
          >
            {t('article.notFound.backToArticles')}
          </Button>
        </Stack>
      </Stack>
    </BodyOverride>
  );
}
